import { useEffect, useState, React } from "react";
import { BrowserRouter, Route, Routes, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuthContext } from "../../Hooks/useAuthContext";
import Spinner from "../../Components/Loading/Spinner";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'

import { apiService } from "../../Axios/apiService"; 


export default function ListUsers() {
    const { user } = useAuthContext();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [users, setUsers] = useState([]);

    // Load users
    useEffect(() => {
        console.log("loading users...");
        console.log("currentUser", user)

        apiService("get", `users/`, null,
            (response) => {
                console.log("Users:", response);
                setUsers(response);
                setLoading(false);
            },
            (error) => {
                console.log(error);
                setLoading(false);
            }
        )
    }, []);



    return (
        <div className="page">
            <div className="row">
                <div className="col-12">
                    {loading && (<Spinner />)}
                    {!loading && (
                        <>
                        <h1>Users <button className="btn-sm btn-primary" onClick={() => { navigate(`/Users/Create/`) }}><FontAwesomeIcon icon={faPlus} /> Add</button> </h1>

                        <table style={{width: "100%"}}>
                            <thead>
                                <tr>
                                    <th>&nbsp;</th>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Role</th>
                                    <th>&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                {users && (users.map((user) => {
                                    return (
                                        <tr key={user.id} style={{ cursor: "pointer" }}>
                                            <td><img src={user.profileImage && user.profileImage} height="25" style={{borderRadius:2}} /></td>
                                            <td onClick={() => { navigate(`/Users/View/${user.id}`) }}>{user.name}</td>
                                            <td onClick={() => { navigate(`/Users/View/${user.id}`) }}>{user.email}</td>
                                            <td onClick={() => { navigate(`/Users/View/${user.id}`) }}>{user.role}</td>
                                            <td>
                                                <Link to={`/Users/View/${user.id}`} className="btn-sm btn-primary">View</Link>
                                                <Link to={`/Users/Edit/${user.id}`} className="btn-sm btn-other">Edit</Link>
                                            </td>
                                        </tr>
                                    )
                                }))}
                            
                            </tbody>
                        </table>
                        </>
                    )}
                </div>
            </div>
        </div>
  )
}
